import { render, staticRenderFns } from "./foodorder.vue?vue&type=template&id=76fff678&scoped=true"
import script from "./foodorder.vue?vue&type=script&lang=js"
export * from "./foodorder.vue?vue&type=script&lang=js"
import style0 from "./foodorder.vue?vue&type=style&index=0&id=76fff678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fff678",
  null
  
)

export default component.exports